var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapBasedOrdering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.999 511.999",
    height: 512,
    viewBox: "0 0 511.999 511.999",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255.919 0c-116.022.34-210.961 94.908-210.961 210.808 0 39.688 10.918 80.124 32.453 120.183 16.936 31.505 40.459 62.858 69.913 93.186 48.041 49.465 104.653 85.219 108.595 87.681l75.518-259.314-75.518-252.539c-.21.001.21-.006 0-.005z",
    fill: "#445373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.943 61.656c-39.893-39.777-92.868-61.691-149.024-61.651v511.853c.144.09 0 .141 0 .141s59.291-36.555 108.981-87.801c29.39-30.311 52.86-61.64 69.76-93.115 21.486-40.021 32.381-80.409 32.381-120.042 0-56.405-22.054-109.457-62.098-149.385z",
    fill: "#363c5a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255.919 72.29-118.381 68.394 118.381 94.414 23.382-89.36z",
    fill: "#9ffcfe"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m374.461 140.684-118.542-68.394v162.808z",
    fill: "#7be2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.538 140.684v136.788l118.381 68.393 25.7-65.659-25.7-71.128z",
    fill: "#7be2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.919 209.078v136.787l118.542-68.393v-136.788z",
    fill: "#29cce8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBasedOrdering);
export default __webpack_public_path__ + "static/media/map-based-ordering.61b50b2e02d7281e404c0b7380fe5cc7.svg";
export { ForwardRef as ReactComponent };